<div class="typog-h3 title">Enter your mobile’s IMEI number</div>
<div class="typog-body-bold mt-4">
  You can find your IMEI number by dialling *#06# from your mobile.
</div>
<form [formGroup]="formGroup" class="inline-flex w-100">
  <dgx-dfb-input
    class="w-100"
    [field]="field"
    [formControlName]="field.controlName"
    #inputApi
  ></dgx-dfb-input>
  <dgx-components-button
    class="m-4"
    disableMode="disable"
    [disabled]="
      formGroup.invalid && !formGroup.get('searchIMEI')?.errors?.invalidAsync
    "
    (click)="
      searchIMEI(
        formGroup.invalid && !formGroup.get('searchIMEI')?.errors?.invalidAsync
      )
    "
  >
    Search
  </dgx-components-button>
</form>
<div class="typog-body-bold mb-4">
  Your IMEI number must be correct so that we can identify your mobile device.
</div>
